var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#043f93;}.cls-2{fill:#45c0b9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkr icons - primary colors - final") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.56,185a3,3,0,0,1-1.17-.24c-2.77-1.17-67.88-29.08-67.88-65.07V32.46A3,3,0,0,1,34,29.51L100,17.05a3,3,0,0,1,1.11,0l66.05,12.46a3,3,0,0,1,2.44,2.95v87.23c0,36-65.11,63.9-67.88,65.07A2.94,2.94,0,0,1,100.56,185Zm-63-150v84.74c0,16.45,17.21,31.66,31.64,41.53a212.67,212.67,0,0,0,31.41,17.5,213.26,213.26,0,0,0,31.4-17.5c14.44-9.87,31.64-25.08,31.64-41.53V35l-63-11.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.6,88H118.51V71.09a18,18,0,0,0-35.9,0V88H72.52a3,3,0,0,0-3,3v41.12a3,3,0,0,0,3,3H128.6a3,3,0,0,0,3-3V91A3,3,0,0,0,128.6,88Zm-40-16.94a12,12,0,0,1,23.9,0V88H88.61Zm37,58.06H75.52V94H125.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.34,114.05l3.45,6.89H94.33l3.45-6.89a6.23,6.23,0,1,1,5.56,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.2e4520d6e6cb0d01efef6dc667e032f4.svg";
export { ForwardRef as ReactComponent };